"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgb2hsb = rgb2hsb;

/**
 * Converts RGB to HSB.
 * @param r Red.
 * @param g Green.
 * @param b Blue.
 */
function rgb2hsb(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var d = max - min;
  var H = 0;
  var S = max === 0 ? 0 : d / max;
  var B = max;

  if (max !== min) {
    switch (max) {
      case r:
        H = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        H = (b - r) / d + 2;
        break;

      case b:
        H = (r - g) / d + 4;
        break;
    }

    H /= 6;
  }

  return {
    h: H * 360,
    s: S * 100,
    b: B * 100
  };
}